<template>
    <div v-if="$wait.is('loading_resource')" class="loading">
        <Spinner :height="40" :width="40"/>
    </div>
    <div
        v-else-if="items && items.length > 0"
        class="user-feed"
    >
        <input type="hidden" v-model="filters.query" />
        <UserSearchResult
            v-for="item in items"
            :key="`sector-post-${item.id}`"
            :resource="item"
        />
        <Pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
        />
    </div>
    <div v-else class="no-results">No results</div>
</template>
<script>
import debounce from 'debounce';
import API from '@api';
import FormControlSector from '@components/Form/Control/FormControlSector';
import FormControlDealType from '@components/Form/Control/FormControlDealType';
import FormControlMember from '@components/Form/Control/FormControlMember';
import FormControlDatepicker from '@components/Form/Control/FormControlDatepicker';
import ListFilterOpportunityType from '@components/List/Filter/ListFilterOpportunityType';
import ColumnOpportunity from '@components/List/ColumnOpportunity';
import OpportunityTableHeader from '@components/Search/Headers/Opportunity';
import SectorPostCard from '@components/Sector/Post/Card';
import UserSearchResult from '@components/Search/Result/User';
import OpportunitySearchResult from '@components/Search/Result/Opportunity';
import Pagination from '@components/List/Pagination';
import Spinner from '@components/Spinner';
import FilterToggle from '@components/Search/FilterToggle.vue';

export default {
    name: 'SearchPageUsers',
    components: {
        FilterToggle,
        UserSearchResult,
        SectorPostCard,
        Pagination,
        FormControlDatepicker,
        OpportunityTableHeader,
        Spinner,
        FormControlMember,
        FormControlDealType,
        FormControlSector,
        ListFilterOpportunityType,
        ColumnOpportunity,
        OpportunitySearchResult,
    },
    props: {
        query: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            filters: {
                query: this.query,
                sectors: [],
                fromDate: null,
                toDate: null,
            },
            items: [],
            paginationMeta: {
                page: 1,
            },
        }
    },
    methods: {
        handleChange: () => {},
        async fetchResource() {
            if(this.$wait.is('loading_resource'))
                return;

            try {
                this.$wait.start('loading_resource');

                const { data, meta } = await API.searchUsers({
                    ...this.filters,
                    page: this.paginationMeta.page,
                });

                this.items = data;
                this.paginationMeta = meta;
            } catch(err) {
                console.warn(err);
                throw new Error(err.message);
            } finally {
                this.$wait.end('loading_resource');
            }
        },
        load() {
            this.fetchResource();
        },
        onChangePage(page) {
            this.paginationMeta = {
                ...this.paginationMeta,
                page
            }

            this.fetchResource();
        },
        handleNavigationToPost(sector_id, post_id) {
            this.$router.push({
                name: 'sector-post-view',
                params: { sector_id, post_id },
            })
        },
    },
    watch: {
        'filters': {
            handler: function() {
                this.onChangePage(1);
            },
            deep: true,
        },
        query: {
            handler: function(newQuery) {
                this.filters.query = newQuery;
            },
            deep: true,
        },
        paginationMeta: {
            handler: function() {
                setTimeout(() => { // Timing issue with $refs being inside a v-if
                    if(this.$refs.pagination) {
                        this.$refs.pagination.setPaginationData(this.paginationMeta);
                    }
                })
            },
            deep: true,
        },
    },
    created() {
        this.handleChange = debounce(
            this.fetchResource.bind(this),
            1200,
        );
    },
}
</script>
<style lang="scss" scoped>
@import "~@/theme/_variables.scss";

.user-feed {
    display: flex;
    flex-direction: column;
    row-gap: 1rem;
}

</style>
